import React, { useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import EmailIcon from "@mui/icons-material/Email";
import logo from "../assets/images/dramrishlogo.png"
const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex justify-center items-center absolute top-0 z-30 w-full flex-col">
      {/* For Top Information  */}
      {/* <div className="w-4/5  xl:w-[75%] gap-4 hidden lg:flex flex-row justify-start p-2.5">
        <div>
          <span className="mr-2">
            <LocationOnIcon
              fontSize="0.75rem"
              color="#17543E"
              className="text-[#17543E]"
            />
          </span>
          <span className="text-sm font-[400] font-lato text-[#17543E]">
            2480 Newberry Rd Waterford, Michigan(MI), 48329, United States
          </span>
        </div>
        <div>
          <span className="mr-2">
            <PhoneEnabledIcon
              fontSize="0.75rem"
              color="#17543E"
              className="text-[#17543E]"
            />
          </span>
          <span className="text-sm font-[400] font-lato text-[#17543E]">
            +1 (248) 673-1563
          </span>
        </div>
        <div>
          <span className="mr-2">
            <EmailIcon
              fontSize="0.75rem"
              color="#17543E"
              className="text-[#17543E]"
            />
          </span>
          <span className="text-sm font-[400] font-lato text-[#17543E]">
            contact@example.com
          </span>
        </div>
      </div> */}

      {/* For Responsive Navbar  */}


    <nav className="bg-transparent w-full">
      <div className="w-full flex flex-wrap items-center justify-between lg:justify-start xl:justify-center  mx-auto  p-4 lg:py-4">
        <a
          href="/"
          className="flex w-1/2 lg:w-[30%] xl:w-2/5 2xl:w-2/5   space-x-3 lg:me-0 2xl:ms-20 rtl:space-x-reverse"
        >
          <img
            src={logo} 
            className="w-60"
            alt="Flowbite Logo"
          />
         
        </a>
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-[#CFA649] rounded-lg lg:hidden hover:bg-[#16563F] focus:outline-none focus:ring-2 focus:ring-[#CFA649]"
          aria-controls="navbar-default"
          aria-expanded={isOpen}
        >
          
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={`${isOpen ? 'block' : 'hidden'} w-full lg:flex lg:justify-start  flex-col lg:flex-row lg:w-[40%]`}
          id="navbar-default"
        >
          <ul className="font-bold flex flex-col p-4  mt-4 border  rounded-lg lg:flex-row lg:space-x-8 rtl:space-x-reverse lg:mt-0 lg:border-0">
            <li>
              <a
                href="/"
                className="block py-2 px-3 text-[16px] lg:w-20 font-raleway md:py-3.5 md:px-6 text-[#16563F] font-bold bg-[#16563F] rounded-sm lg:bg-transparent  lg:p-0"
                aria-current="page"
              >
                Home 1
              </a>
            </li>
            <li>
              <a
                href="/home-2"
                className="block py-2 px-3 text-[16px] lg:w-20 font-raleway md:py-3.5 md:px-6 text-[#16563F] font-bold rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-[#CFA649] lg:p-0"
              >
                Home 2
              </a>
            </li>
            <li>
              <a
                href="#/"
                className="block py-2 px-3 text-[16px] lg:w-20 font-raleway md:py-3.5 md:px-6 text-[#16563F] font-bold rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-[#CFA649] lg:p-0"
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#/"
                className="block py-2 px-3 text-[16px] lg:w-20 font-raleway md:py-3.5 md:px-6 text-[#16563F] font-bold rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-[#CFA649] lg:p-0"
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                href="#/"
                className="block py-2 px-3 text-[16px] font-raleway md:py-3.5 md:px-6 text-[#16563F] font-bold rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 md:hover:text-[#CFA649] lg:p-0"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
 

    </div>
  );
};

export default NavBar;
